import React, {Component} from 'react';
import { Badge, Row, Col, Card, CardHeader,  CardBody, ListGroup, Table, ListGroupItem } from 'reactstrap';
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';


class KeyAttributeHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(!this.props.product)
            return <div></div>;

        console.log("this.props.product", this.props.product);
        return (
            <Row className="p-2" >
                <Col lg={4}>{}</Col>
                <Col lg={4} className="d-flex justify-content-center">
                    <h1> <Badge color="primary" className="" style={{fontSize: 30}}>{this.props.product.key.kid}</Badge>
                        {this.props.product.bundleComposition.length !== 0 &&
                            <Badge className="ml-2 kit-badge" style={{fontSize: 30}}>Kit</Badge>}
                    </h1>
                </Col>
                <Col lg={4} className="d-flex justify-content-end">
                    <div>
                        {_getBadge({value: this.props.product.key.upcEanGtin})}
                        {_getBadge({value: this.props.product.key.modelNumber})}
                        {_getBadge({value: this.props.product.key.piShopSku, link: `https://dashboard.pishop.com/us/products/${this.props.product.key.piShopSku}`})}
                        {_getBadge({value: this.props.product.key.keywords})}
                        {_getBadge({value: this.props.product.detail.indicators.archived, color: "danger"})}
                    </div>
                </Col>
            </Row>);

    }
}

function _getBadge({value, color="secondary", link}){
    if(!value)
        return;
    //&nbsp; prevents double click from selecting on adjacent divs
    return (
        <div className="d-inline">
            <Badge color={color} className="mr-1 mt-3" style={{fontSize: 20}}>
                {value}
                {link && (
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="ml-2 text-white"
                        style={{textDecoration: 'none'}}
                    >
                        <FontAwesomeIcon icon={faExternalLinkAlt} size="sm" />
                    </a>
                )}
            </Badge>
            &nbsp;
        </div>
    );
}

export default KeyAttributeHeader;
